import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
